export enum ReOrganizationRole {
  tctd_chia_chi_tieu = 'TCTD_CHIA_CHI_TIEU',
  tctd_them_data = 'TCTD_THEM_DATA',
  tctd_xem_chi_tiet_chien_dich = 'TCTD_XEM_CHI_TIET_CHIEN_DICH',
  tctd_xem_danh_sach = 'TCTD_XEM_DANH_SACH',
  tctd_xem_data = 'TCTD_XEM_DATA',
  tctd_xem_data_da_xoa = 'TCTD_XEM_DATA_DA_XOA',
  tctd_xem_tong_quan = 'TCTD_XEM_TONG_QUAN',
}
